import React from 'react'
import renderChildUIComponents from './metadata-mapper'
import {observer } from "mobx-react";
import {observable} from 'mobx'
import {DataTable, DataTableColumnCfg} from "../base-components/DataTable"
import {createContext, getParentFromBinding} from '../../utils/metadata-utils'
import * as api from "../../api";
import { AllowSelectionEnum, FlatDomainDataContext, FormBean, IContextObject, IDomainData, IUIBaseInputDef, IUIDataGridDef, IViewContext } from '../../datatypes';

const {MDBBtn, MDBIcon, MDBInput} = require('mdbreact');

interface DataGridProps {
    metadata:IUIDataGridDef;
    formBean:FormBean;
    ctx:FlatDomainDataContext;  
}

interface DataGridSelectionCtx {domainDataCtx:FlatDomainDataContext,namePrefix:string};

function isSelectedObject(item: IDomainData){
  return item._selected ;
}

class DataGridSection extends React.Component<DataGridProps,{}> {
  private bindedList: IDomainData[] = [];
  private ctxArray: DataGridSelectionCtx[] = []; 

  constructor(props:DataGridProps) {
    super(props);

    const {metadata, ctx} = this.props;
    const {listBinding} = metadata;

    this.state = {}
    this.populateBindedListAndContext(ctx, listBinding);
  }

  addNewContext = (item: IDomainData | IDomainData[], idx: string | number) => {
    const {ctx, metadata} = this.props;
    const {listBinding} = metadata;
    let namePrefix = `${listBinding}[${idx}]_`;

    let itemContext = createContext(ctx[listBinding].metaData, item);
    // console.debug(`createContext`, itemContext);

    let newContext = {domainDataCtx:{
                        ...this.props.ctx,
                        ...itemContext,
                        }, 
                        namePrefix:namePrefix
                    };
    if(!this.ctxArray) this.ctxArray = [];
    this.ctxArray.push(newContext);
  }

  getNewCtx = (item: IDomainData | IDomainData[], idx: number) => {
    const {ctx, metadata} = this.props;
    const {listBinding} = metadata;
    let namePrefix = `${listBinding}[${idx}]_`;

    let itemContext = createContext(ctx[listBinding].metaData, item);

    let newContext:DataGridSelectionCtx = {domainDataCtx: {
                                                            ...this.props.ctx,
                                                            ...itemContext,
                                                            
                                                           }, 
                                           namePrefix:namePrefix
                                          };
    return newContext;
  }

  /**
   * populate binding list and add new context accordingly
   * @param ctx observable context
   * @param listBinding the name of listBinding in ObjectName.Attribute format
   */
  populateBindedListAndContext = (ctx:FlatDomainDataContext, listBinding:string) => {
    let repeatableList:IDomainData[] = ctx[listBinding] ? (ctx[listBinding].data as IDomainData[]) : [];

    this.bindedList = repeatableList;
    for(let idx in this.bindedList) {
      this.addNewContext(this.bindedList[idx], idx);
    }
  }

  addAnother = async(bindedList:IDomainData[], listBinding:string) => {
    //this is binded list from mobx,
    //any updates here will be pushed to the mobx state
    let repeatableData = await api.getEmptyDomainObject(listBinding, this.props.formBean.ClientCode);

    //Make all properties observable before spreading them into the context
    repeatableData = observable.object(repeatableData);
    const {childViewName} = this.props.metadata;

    if(childViewName){
      let newCtx = this.getNewCtx(repeatableData, bindedList.length);
      let obj:IContextObject = {
        operation: "Add",
        newCtx: newCtx.domainDataCtx,
        id: repeatableData.Id
      }

      let callback = (b: boolean) =>{
        if(b){
          this.addNewContext(repeatableData, bindedList.length);
          bindedList.push(repeatableData);
        }
      };
      this.props.formBean.changeView!(childViewName, obj, callback);
    } else{
      this.addNewContext(repeatableData, bindedList.length);
      bindedList.push(repeatableData);
    }
  }

  getParentFromProps = () => {
    let parent = getParentFromBinding(this.props.metadata.listBinding);
    return this.props.ctx[parent!];
  }

  editObj = async (bindedList:IDomainData[], index:number) => {
    const {childViewName,listBinding} = this.props.metadata;
    let obj:IContextObject = {
      operation: "Edit",
      newCtx: this.ctxArray[index].domainDataCtx,
      // @ts-ignore
      id: this.ctxArray[index].domainDataCtx[listBinding].data.Id
    }
    if(childViewName) this.props.formBean.changeView!(childViewName, obj)

  }


  selectObj = async (bindedList:IDomainData[], index:number, type:AllowSelectionEnum) => {
    // making _selected as true
    if(type === "SINGLE") {
      bindedList.forEach((o,i) => {
        if(i === index) {
          o._selected = true;
        }else {
          o._selected = false;
        }
      })
    }else if(type === "MULTIPLE"){
      bindedList[index]._selected = !bindedList[index]._selected;
    }

  }

  calculateLabel = (metadata:IUIBaseInputDef) => {
    //switch, checkbox do not have the property required. So they do not need the logic of calculating (optional) in the label.
    let componentsWithoutRequired = ['SwitchCol', 'CheckboxCol'];

    if(componentsWithoutRequired.includes(metadata.type)) return metadata.label;
    else {
      let label = metadata.required ? metadata.label : metadata.label + ' (optional)';
      return label;
    }
  }
  removeObj = async (bindedList:IDomainData[], index:number) => {
    // doing soft delete by updating the deleted flag
    bindedList[index]._deleted = true;
  }



  render() {
    const {metadata, formBean, ctx} = this.props;
    const {
      title,
      listBinding,
      allowSelection,
      enableAdd,
      enableEdit,
      enableDelete,
      filter,
    } = metadata;

    // let className = "baseContainer dataGrid" + (this.props.className ? this.props.className : '');
    // className += (cssClasses ? " " + cssClasses : '');

    let repeatableList = this.bindedList||[];
    let isSelectedOnly = filter == 'SELECTED_ONLY';

    let tableHeaders = [] as DataTableColumnCfg[];
    if(allowSelection && allowSelection === "SINGLE" || allowSelection === "MULTIPLE") {
      let columnData = {
        label: '',
        field: 'AllowSelection',
        sort: 'asc',
        width: 5
      }
      tableHeaders.push(columnData);

    }
    metadata.children.map((compMetadata, idx) => {
      let field = compMetadata.componentId.includes(".") ? compMetadata.componentId.split(".")[compMetadata.componentId.split(".").length-1]
          :compMetadata.componentId;
      let label = this.calculateLabel(compMetadata);
      let columnData = {
        label: label,
        field: field,
        sort: 'asc',
        width: 50
      }
      tableHeaders.push(columnData);
    });

    if(enableEdit || enableDelete) {
      let columnData = {
        label: '',
        field: 'EnableEditDelete',
        sort: 'asc',
        width: 5
      }
      tableHeaders.push(columnData);

    }


    let tableRows = repeatableList.map((item, idx) => {
      let result = {} as {[key:string]:JSX.Element}
      if(item && item._deleted || (isSelectedOnly && !isSelectedObject(item))) {
        return null;
      }
      if(!this.ctxArray || this.ctxArray.length <= idx || !this.ctxArray[idx]) {
        //A new item was added to the binded list, we should update the context array
        //This is better than creating a ctx array on every render
        //Another way to do this will be watch for new props etc
        this.addNewContext(item, idx);
      }
      if(allowSelection && allowSelection === "SINGLE") {
        result['AllowSelection'] = <MDBInput
            id={"repeatable-select-radio-" + idx}
            type={"radio"}
            checked={repeatableList[idx]._selected || false}
            onClick={() => this.selectObj(repeatableList, idx, "SINGLE")}
            label={" "}
        >
        </MDBInput>
      }
      else if(allowSelection && allowSelection === "MULTIPLE") {
        result['AllowSelection'] = <MDBInput
            id={"repeatable-select-checkbox-"+idx}
            type='checkbox'
            filled
            checked = {repeatableList[idx]._selected || false}
            onClick={() => this.selectObj(repeatableList, idx, "MULTIPLE")}
            label={" "}
        >
        </MDBInput>
      }


      //ToDo: Does this need a purewrapper too?
      let components = renderChildUIComponents({metadata, formBean, ctx: this.ctxArray[idx].domainDataCtx});
      (components||[]).map(c =>{
          // @ts-ignore
        result[c.props.cId] = c;
      })

      if(enableEdit || enableDelete){
        result['EnableEditDelete'] =
            <React.Fragment>
              {enableEdit && <MDBIcon id={"datagrid-edit-"+idx} className={'data-grid-ui-renderer-edit'} onClick={() => this.editObj(repeatableList, idx)} icon={'edit'}/>}
              {enableDelete && <MDBIcon id={"datagrid-remove-"+idx} className={'data-grid-ui-renderer-delete'} onClick={() => this.removeObj(repeatableList, idx)} icon={'times'}/>}
            </React.Fragment>
      }

      return result;
    })



    //when none of the elements have _selected as true, and the filter is SELECTED, the array contains nulls.
    tableRows = tableRows.filter(v=>v != null);
    const table_data = {
      columns: tableHeaders||[],
      rows: tableRows as {[key:string]:JSX.Element}[]
    }

    return (
        <React.Fragment>
          {title && <h3 className="mdHeading datagridHeading">{title}</h3>}
              <React.Fragment>
                  <DataTable
                      striped = {false}
                      bordered = {true}
                      hover = {false}
                      hideFooter={true}
                      className={' data-grid-ui-renderer datagridTable '}
                      showEntries={false}
                      data={table_data}
                      searching={false}
                      info={false}
                      sortable={false}
                      paging={false}
                  />
                </React.Fragment>
          {enableAdd &&
            <MDBBtn className="btn btn-white btn-outline-grey datagridAdd" onClick={() => this.addAnother(repeatableList, listBinding)}>
              <MDBIcon className={"datagridAddIcon"} icon={"plus"} />
              {"Add"}
            </MDBBtn>
          }


        </React.Fragment>


    )
  }
}

export default observer(DataGridSection);